export { registerComponent as registerEmbedComponent } from '../../components/builtin/Embed/register'
export { default as Embed } from '../../components/builtin/Embed/Embed'
